import { get } from "lodash";
import { thor } from "../../typings/thor";
import { Status } from "./organization-dialog-base.controller";
import { Membership } from "../../typings/organization";
import { isAdvertiser, isMember } from "../../utils/organization";

interface OrganizationSearchFilterParams {
    query: string;
    status: Status;
    membership: Membership;
}

export class OrganizationSearchFilter {
    public static $inject: string[] = ["sitesService"];

    constructor(sitesService) {
        return (organizations, filterParams: OrganizationSearchFilterParams) => {
            const propertyPathsToFilter: string[] = ["names.voluntary", "names.judicial", "login", "address.city"];

            return organizations.filter((organization: thor.Organization) => {
                const propertiesWithResult = [];
                let isFound: boolean = true;
                organization.$filterPropertiesWithResult = [];

                if (filterParams.query) {
                    const searchQuery = filterParams.query.toLowerCase();

                    propertyPathsToFilter.forEach(propertyPath => {
                        const propertyValue = (get(organization, propertyPath, "") || "").toLowerCase();

                        if (propertyValue && propertyValue.search(searchQuery) !== -1) {
                            propertiesWithResult.push(propertyPath);
                        }
                    });

                    organization.$filterPropertiesWithResult = propertiesWithResult;

                    isFound = propertiesWithResult.length > 0;
                }

                const filterStatus: Status = filterParams.status;
                const filterMembership: Membership = filterParams.membership;

                if (isFound && filterStatus) {
                    isFound = get(organization, `status.${filterStatus}`);
                }
                if (isFound && filterMembership) {
                    isFound =
                        (filterMembership === Membership.Advertiser && isAdvertiser(organization)) ||
                        (filterMembership === Membership.Member && isMember(organization));
                }

                return isFound;
            });
        };
    }
}
